export const CONTENT_EXPERIENCE = {
  pageBg: 'solid.0',
  heroBg: 'background.White',
  warmPanelBg: 'background.White',
  infoPanelBg: 'background.White',
  glassPanelBg: 'background.White',
  glassBorder: 'solid.50',
  cardBorder: 'solid.50',
  heroShadow: '0 1px 3px rgba(0,0,0,0.06)',
  softShadow: '0 1px 3px rgba(0,0,0,0.06)',
  glassShadow: '0 1px 3px rgba(0,0,0,0.06)',
  panelRadius: '12px',
  cardRadius: '10px',
}

export const contentModeCopy = {
  admin: {
    heading: 'Edit content flow',
    description: 'Manage pages, learning material, questions, scoring, and what learners will see.',
  },
  user: {
    heading: 'Start content',
    description: 'Open the learner view, work through each page, and complete the required final steps.',
  },
}
